'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function AWFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-6y5zjnequ", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-su0pwrdjt", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-yg5l4dvh1" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-yg5l4dvh1", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-6y5zjnequ)" }, /* @__PURE__ */ React.createElement("use", { fill: "#5ba3da", xlinkHref: "#mantine-yg5l4dvh1" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-su0pwrdjt)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "red",
        stroke: "#f7fcff",
        strokeWidth: ".35",
        d: "M5.773 7.96l-4.38-.925 4.434-.878 1.283-4.59L8.122 6.12l3.96.92-3.914.92-1.129 3.743z"
      }
    ), /* @__PURE__ */ React.createElement("path", { fill: "#fad615", d: "M32 18v2H0v-2zm0-4v2H0v-2z" }))))
  );
}

export { AWFlag };
//# sourceMappingURL=AW.mjs.map
